import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { TestModeBanner } from "../components/TestModeBanner";
import { SavedProvider } from "../saved/SavedContext";

/** App shell: a fixed left sidebar (static on desktop, a drawer on mobile) with
 *  the routed surface in the main column. */
export function Layout() {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("rt.sidebar.collapsed") === "1";
    } catch {
      return false;
    }
  });

  function toggleCollapse() {
    setCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem("rt.sidebar.collapsed", next ? "1" : "0");
      } catch {
        /* storage unavailable — collapse state is best-effort */
      }
      return next;
    });
  }

  return (
    <SavedProvider>
    <div className="flex min-h-screen">
      {/* Desktop sidebar — sticky, full-height */}
      <div className="sticky top-0 hidden h-screen shrink-0 lg:block">
        <Sidebar collapsed={collapsed} onToggleCollapse={toggleCollapse} />
      </div>

      {/* Mobile drawer */}
      {open && <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={() => setOpen(false)} aria-hidden />}
      <div
        className={`fixed inset-y-0 left-0 z-50 transition-transform lg:hidden ${open ? "translate-x-0" : "-translate-x-full"}`}
      >
        <Sidebar onNavigate={() => setOpen(false)} />
      </div>

      {/* Main column */}
      <div className="flex min-w-0 flex-1 flex-col">
        <TestModeBanner />
        <TopBar onMenu={() => setOpen(true)} />
        <main className="mx-auto w-full max-w-6xl flex-1 px-5 py-8 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
    </SavedProvider>
  );
}
